import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { sliceContent } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
export function Paragraph(_ref) {
  var content = _ref.content,
      twStyle = _ref.twStyle,
      children = _ref.children,
      variant = _ref.variant,
      font = _ref.font,
      color = _ref.color,
      align = _ref.align,
      standardVariant = _ref.standardVariant,
      isPointer = _ref.isPointer,
      maxChars = _ref.maxChars;
  var convertedVariant = mapVariantToStandard(variant);
  var convertedContent = maxChars && content ? sliceContent(content, maxChars) : content;
  return /*#__PURE__*/_jsx(ParagraphUI, {
    twStyle: twStyle,
    variant: convertedVariant,
    font: font,
    color: color,
    align: align,
    standardVariant: standardVariant,
    isPointer: isPointer,
    children: convertedContent || children
  });
}
export default Paragraph;

var ParagraphUI = /*#__PURE__*/_styled.p.withConfig({
  displayName: "paragraph__ParagraphUI",
  componentId: "sc-11gysep-0"
})(function (_ref2) {
  var twStyle = _ref2.twStyle,
      variant = _ref2.variant,
      color = _ref2.color,
      font = _ref2.font,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? 'left' : _ref2$align,
      standardVariant = _ref2.standardVariant,
      isPointer = _ref2.isPointer;
  return [{
    "whiteSpace": "pre-wrap",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  }, // variant === 'body' && tw`lg:text-base lg:leading-6 md:text-sm   md:leading-5.25 leading-6 text-base`,
  // variant === 'body-small' && tw`lg:text-sm text-xs  lg:leading-5.25 leading-4.5`,
  // variant === 'caption' && tw`text-sm font-normal`,
  // variant === 'label' && tw`text-sm font-normal`,
  // variant === 'span' && tw`text-base font-normal`,
  // variant === 'link-text' && tw`lg:text-sm text-sm font-medium leading-5.25`,
  // variant === 'medium' && tw`lg:text-xl text-sm leading-7.5 font-normal`,
  // variant === 'small' && tw`lg:text-sm text-sm lg:leading-5.25 leading-5.25`,
  // variant === 'xsmall' && tw`lg:text-xs text-xs  lg:leading-4.5 leading-4.5`,
  //lg:text-sm lg:leading-5.25 !text-sm !leading-5.25
  variant && standardParagraphVariants[variant], color && colorMap[color], align && alignment[align], standardVariant && standardParagraphVariants[standardVariant], isPointer && {
    "cursor": "pointer"
  }, font && fontMapping[font]].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});

var colorMap = {
  'gray-400': {
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))"
  },
  'gray-500': {
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  },
  'gray-600': {
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  'primary-800': {
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  },
  black: {
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  },
  'red-600': {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  },
  'primary-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  },
  'primary-900': {
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  'primary-100': {
    "--tw-text-opacity": "1",
    "color": "rgb(226 216 243 / var(--tw-text-opacity))"
  }
};
var fontMapping = {
  medium: {
    "fontWeight": "500"
  },
  normal: {
    "fontWeight": "400"
  },
  semibold: {
    "fontWeight": "600"
  },
  bold: {
    "fontWeight": "700"
  }
};
var alignment = {
  left: {
    "textAlign": "left"
  },
  center: {
    "textAlign": "center"
  },
  right: {
    "textAlign": "right"
  },
  justify: {
    "textAlign": "justify"
  }
};
export var standardParagraphVariants = {
  'body-l': {
    "fontSize": "20px",
    "fontWeight": "400",
    "lineHeight": "30px",
    "@media (min-width: 1024px)": {
      "fontSize": "20px",
      "lineHeight": "30px"
    }
  },
  'body-m': {
    "fontSize": "16px",
    "fontWeight": "400",
    "lineHeight": "24px",
    "@media (min-width: 1024px)": {
      "fontSize": "16px",
      "lineHeight": "24px"
    }
  },
  'body-sm': {
    "fontSize": "14px",
    "fontWeight": "400",
    "lineHeight": "21px",
    "@media (min-width: 1024px)": {
      "fontSize": "14px",
      "lineHeight": "21px"
    }
  },
  'label-m': {
    "fontSize": "16px",
    "fontWeight": "500",
    "lineHeight": "24px",
    "@media (min-width: 1024px)": {
      "fontSize": "16px",
      "lineHeight": "24px"
    }
  },
  'label-s': {
    "fontSize": "14px",
    "fontWeight": "600",
    "lineHeight": "21px",
    "@media (min-width: 1024px)": {
      "fontSize": "14px",
      "lineHeight": "21px"
    }
  }
};
export var mapVariantToStandard = function mapVariantToStandard(inputVariant) {
  switch (inputVariant) {
    case 'medium':
      return 'body-l';

    case 'body':
    case 'span':
      return 'body-m';

    case 'body-small':
    case 'caption':
    case 'label':
    case 'link-text':
    case 'small':
    case 'xsmall':
      return 'body-sm';

    default:
      return 'body-m';
  }
};